import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { PocBanner } from "./PocBanner";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      <PocBanner />
      <ErrorBoundary FallbackComponent={Error}>
        <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
          {/* Clear the fixed bottom nav. Without this it covers the last rows of
              every page and swallows their clicks. 72px matches the offset the
              notification below already uses. */}
          <div
            className="min-w-0 overflow-x-hidden bg-muted/40 px-3 pb-[88px] pt-3"
            id="main-content"
          >
            {children}
          </div>
        </Suspense>
      </ErrorBoundary>
      <MobileNavigation />
      <Notification mobileOffset={{ bottom: "72px" }} />
    </>
  );
};
